<div class="input-container">
    <div [ngSwitch]="activeInputMenuItem">
        <div class="input-container" *ngSwitchCase="'Corporate Info'">
            <kve-corporate-info></kve-corporate-info>
        </div>
        <div class="input-container" *ngSwitchCase="'Commercial Policies'">
            <kve-commercial-policiea></kve-commercial-policiea>
        </div>
        <div class="input-container" *ngSwitchCase="'Customer Relations'">
            <kve-customer-relations></kve-customer-relations>
        </div>
        <div class="input-content" *ngSwitchDefault>
            <nb-tabset (changeTab)="tabChanged($event)">
                <nb-tab tabTitle={{defaultInputMenuItem}}>
                    <nb-accordion multi kwExpandFirstItem>
                        <nb-accordion-item expanded>
                            <nb-accordion-item-header>Corporate Info</nb-accordion-item-header>
                            <nb-accordion-item-body class="inner-cell">
                                <kve-corporate-info></kve-corporate-info>
                            </nb-accordion-item-body>
                        </nb-accordion-item>
                        <nb-accordion-item>
                            <nb-accordion-item-header>Commercial Policies</nb-accordion-item-header>
                            <nb-accordion-item-body class="inner-cell">
                                <kve-commercial-policiea></kve-commercial-policiea>
                            </nb-accordion-item-body>
                        </nb-accordion-item>
                        <nb-accordion-item>
                            <nb-accordion-item-header>Social Media</nb-accordion-item-header>
                            <nb-accordion-item-body class="inner-cell">
                                <kve-customer-relations></kve-customer-relations>
                            </nb-accordion-item-body>
                        </nb-accordion-item>
                    </nb-accordion>
                </nb-tab>
                <nb-tab tabTitle="Sections">
                    <ngx-footer-items></ngx-footer-items>
                    <!-- <nb-accordion multi kwExpandFirstItem>
                        <nb-accordion-item expanded>
                            <nb-accordion-item-header>Corporate Info</nb-accordion-item-header>
                            <nb-accordion-item-body class="inner-cell">
                                <kve-corporate-info></kve-corporate-info>
                            </nb-accordion-item-body>
                        </nb-accordion-item>
                        <nb-accordion-item>
                            <nb-accordion-item-header>Commercial Policies</nb-accordion-item-header>
                            <nb-accordion-item-body class="inner-cell">
                                <kve-commercial-policiea></kve-commercial-policiea>
                            </nb-accordion-item-body>
                        </nb-accordion-item>
                        <nb-accordion-item>
                            <nb-accordion-item-header>Social Media</nb-accordion-item-header>
                            <nb-accordion-item-body class="inner-cell">
                                <kve-customer-relations></kve-customer-relations>
                            </nb-accordion-item-body>
                        </nb-accordion-item>
                    </nb-accordion> -->
                </nb-tab>
            </nb-tabset>
        </div>
    </div>
    
</div>
